import script from "./visionPage.vue?vue&type=script&setup=true&lang=js"
export * from "./visionPage.vue?vue&type=script&setup=true&lang=js"

import "./visionPage.vue?vue&type=style&index=0&id=28e839d0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28e839d0"]])

export default __exports__